import React, { useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faCloudUploadAlt, faSpinner } from '@fortawesome/free-solid-svg-icons';

const FileUploader = ({ onUpload, disabled = false }) => { // Добавлен пропс disabled
  const fileInputRef = useRef(null);
  const [isDragOver, setIsDragOver] = useState(false);
  const [uploading, setUploading] = useState(false);

  const handleFileSelect = async (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      await processFiles(files);
    }
  };

  const handleButtonClick = () => {
    if (!disabled && !uploading) {
      fileInputRef.current?.click();
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    if (!disabled && !uploading) {
      setIsDragOver(true);
    }
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragOver(false);
  };

  const handleDrop = async (e) => {
    e.preventDefault();
    setIsDragOver(false);
    
    if (disabled || uploading) return;
    
    const files = Array.from(e.dataTransfer.files);
    if (files.length > 0) {
      await processFiles(files);
    }
  };

  const processFiles = async (files) => {
    try {
      setUploading(true);
      await onUpload(files);
    } catch (error) {
      console.error('Error processing files:', error);
    } finally {
      setUploading(false);
      // Сбрасываем значение input, чтобы можно было выбрать тот же файл снова
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
  };

  return (
    <div 
      className={`file-uploader ${isDragOver ? 'drag-over' : ''} ${disabled || uploading ? 'disabled' : ''}`}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      style={{
        opacity: disabled || uploading ? 0.6 : 1,
        pointerEvents: disabled || uploading ? 'none' : 'auto',
        cursor: disabled || uploading ? 'not-allowed' : 'auto'
      }}
    >
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileSelect}
        multiple
        style={{ display: 'none' }}
        accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.gif"
        disabled={disabled || uploading}
      />
      
      {uploading ? (
        <FontAwesomeIcon 
          icon={faSpinner} 
          className="mb-3 fa-spin" 
          style={{ fontSize: '3rem', color: '#6c757d' }} 
        />
      ) : (
        <FontAwesomeIcon 
          icon={faCloudUploadAlt} 
          className="mb-3" 
          style={{ fontSize: '3rem', color: '#6c757d' }} 
        />
      )}
      
      <div className="mb-3">
        <Button 
          variant="primary" 
          onClick={handleButtonClick}
          disabled={disabled || uploading}
        >
          {uploading ? (
            <>
              <FontAwesomeIcon icon={faSpinner} className="me-2 fa-spin" />
              Завантаження...
            </>
          ) : (
            <>
              <FontAwesomeIcon icon={faUpload} className="me-2" />
              Обрати файли
            </>
          )}
        </Button>
      </div>
      
      <div className="text-muted small">
        <div>Перетягніть файли сюди або натисніть кнопку</div>
        <div>Максимальний розмір файлу: 10MB</div>
        <div>Дозволені формати: PDF, DOC, DOCX, XLS, XLSX, JPG, PNG, GIF</div>
        {(disabled || uploading) && (
          <div className="text-warning mt-2">
            {uploading ? 'Завантаження файлів...' : 'Завантаження тимчасово недоступне'}
          </div>
        )}
      </div>
    </div>
  );
};

export default FileUploader;